module.exports = __webpack_public_path__ + "img/photo7.1e7ef4ac.jpg";